import { readState } from "@/__main__/app-state.mjs";
import { serializeValue } from "@/__main__/db.mjs";
import { postData } from "@/__main__/get-data.mjs";
import { appURLs } from "@/app/constants.mjs";
import * as GQL from "@/feature-auth/fetches/user-preferences-client-gql.mjs";
import UpdateUserPreferencesResponseModel from "@/feature-auth/models/update-user-preferences-model.mjs";
import getBearerToken from "@/feature-auth/utils/get-auth-request-header.mjs";
import {} from "@/library/actions.mjs";
import { devError } from "@/util/dev.mjs";

export async function updateUserPreferences(preferences: object) {
  if (!readState.user) return;

  let bearerToken, error;

  try {
    bearerToken = await getBearerToken();
  } catch (e) {
    error = e;
  }

  if (!bearerToken) {
    devError("FAILED TO UPDATE USER SETTINGS - no bearer token!", error);
    return;
  }

  await postData(
    {
      url: appURLs.AUTH_GRAPHQL,
      body: {
        query: GQL.UpdateUserPreferences,
        variables: {
          preferences: JSON.stringify({
            blitzApp: await serializeValue(preferences),
          }),
        },
      },
    },
    UpdateUserPreferencesResponseModel,
    // discard the result as it's not really needed
    undefined,
    { headers: { Authorization: bearerToken } },
  );
}
